import { resolveRefSync } from '@redneckz/json-ref';
export const resolveBlockProps = (content, fallback) => resolveRefSync(content, (_) => fallback?.[_]);
//# sourceMappingURL=resolveBlockProps.js.map